export type StatsNoticeVisibilityInput = {
  isAuthenticated: boolean
  /** La query `appConfig` a répondu (ou a échoué) — cf. `Branding.loaded`. */
  brandingLoaded: boolean
  /** Un déclencheur manuel (lien « Mes données ») demande l'ouverture. */
  manualOpen: boolean
  /** La version courante de la notice n'a pas encore été acquittée. */
  unacknowledged: boolean
  /** L'apprenant a fermé la présentation automatique pendant cette session. */
  autoDismissed: boolean
}

/**
 * La notice de suivi statistique doit-elle être affichée ?
 *
 * Sortie du composant pour être épinglée sans monter React ni Apollo : deux
 * règles s'y croisent et se sont déjà contredites.
 *
 * 1. La notice cite le nom de la plateforme dès sa première phrase, donc on
 *    attend que le branding ait répondu — sinon l'apprenant voit le nom par
 *    défaut se corriger sous ses yeux (#35).
 * 2. Fermer sans acquitter écarte la présentation automatique, mais n'empêche
 *    jamais une réouverture manuelle : l'information doit rester consultable à
 *    tout moment (art. 13).
 */
export function shouldShowStatsNotice(input: StatsNoticeVisibilityInput): boolean {
  if (!input.isAuthenticated || !input.brandingLoaded) return false
  if (input.manualOpen) return true
  return input.unacknowledged && !input.autoDismissed
}
